import { render } from "./WorkspacePickerSimple.vue?vue&type=template&id=1ebf5230&scoped=true"
import script from "./WorkspacePickerSimple.vue?vue&type=script&lang=js"
export * from "./WorkspacePickerSimple.vue?vue&type=script&lang=js"

import "./WorkspacePickerSimple.vue?vue&type=style&index=0&id=1ebf5230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebf5230"]])

export default __exports__